// extracted by mini-css-extract-plugin
export default {"feedback":"Feedback_feedback__WJhMB"};